var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.isMob)?_c('mob-wrap',{attrs:{"userName":_vm.loginInfo.userName}}):_c('pc-wrap')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }